import React, { useState } from "react";
import { Tabs, Tab } from "react-bootstrap";
import GetSummary from "./GetSummary";

const SummaryTabs = () => {
    const [activeTab, setActiveTab] = useState("document"); // Default: document

    return (
        <Tabs
            activeKey={activeTab}
            onSelect={(k) => setActiveTab(k)}
            className="gap-3 summary-tab" 
        >
            <Tab eventKey="document" title="Document Type">
                <GetSummary type="document" />
            </Tab>
            <Tab eventKey="length" title="Length Type">
                <GetSummary type="length" />
            </Tab>
        </Tabs>
    );
};

export default SummaryTabs;
